// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiResubmission {
    static getAttributeTypeMap() {
        return PharmacyBiResubmission.attributeTypeMap;
    }
}
PharmacyBiResubmission.discriminator = undefined;
PharmacyBiResubmission.additionalProperties = false;
PharmacyBiResubmission.attributeTypeMap = [
    {
        "name": "notificationMethod",
        "baseName": "notificationMethod",
        "type": "string"
    },
    {
        "name": "turnaroundTime",
        "baseName": "turnaroundTime",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiResubmission.js.map